import {
  settlementConstants,
  httpVerbConstants,
} from '../constants/actionTypes'
import { FetchSettlementService } from '../services/settlementService'
import {
  ISettlementRecipient,
  ISettlementValue,
} from 'application/components/pages/ISettlementInputProps'

const settlementRequest = () => ({
  type: settlementConstants.FETCH_SETTLEMENT_REQUEST,
})

const settlementSuccess = (data: any) => ({
  type: settlementConstants.FETCH_SETTLEMENT_SUCCESS,
  payload: data,
})

export const consultantSettlement = (
  opportunityId: string,
  headers: { accessToken: string }
) => {
  return (dispatch: any) => {
    let settlementValue: ISettlementValue = {
      isValid: false,
      recipients: [],
    }

    dispatch(settlementRequest())
    return FetchSettlementService(
      opportunityId,
      headers,
      httpVerbConstants.HTTP_GET
    ).then(
      (data: ISettlementValue) => {
        if (data == null) {
        } else {
          settlementValue = data
          settlementValue.recipients.forEach(
            (r: ISettlementRecipient) => (r.signingURL = '')
          )
        }

        dispatch(settlementSuccess(settlementValue))
      },
      (error) => {
        console.error(`Error: ${error}`)
        dispatch(settlementSuccess(settlementValue))
      }
    )
  }
}
